<script>
    import { preventDefault } from 'svelte/legacy';
    import { editorState } from "@app/store/editorStore.svelte.js";
    import * as m from "@app/paraglide/messages.js";

    function updateEditorSettings() {
        localStorage.setItem(
            "cc-editor-defaults",
            JSON.stringify(editorState),
        );
    }
</script>

<h5>{m.options_editor_title()}</h5>
<p class="small text-muted">
    {m.options_editor_note()}
</p>
<form id="editorSettingsForm" onsubmit={preventDefault(updateEditorSettings())} aria-label={m.options_editor_form_label()}>
    <!-- Transcription -->
    <div class="row">
        <p class="lead text-warning">{m.options_editor_section_transcription()}</p>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    id="insertStartCheck"
                    type="checkbox"
                    class="form-check-input"
                    bind:checked={editorState.insertStartOnInsert}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                    aria-labelledby="insertStartLabel"
                />
                <label id="insertStartLabel" class="form-check-label" for="insertStartCheck"
                    >{m.options_editor_insert_start_tc()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_insert_start_tc_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="insertEndCheck"
                    bind:checked={editorState.insertEndOnInsert}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="insertEndCheck"
                    >{m.options_editor_insert_end_tc()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_insert_end_tc_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="autoLineBreakCheck"
                    bind:checked={editorState.autoLineBreak}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="autoLineBreakCheck"
                    >{m.options_editor_auto_line_breaks()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_auto_line_breaks_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Auto Insert Event -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="autoInsertEventCheck"
                    bind:checked={editorState.autoInsertEvent}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="autoInsertEventCheck"
                    >{m.options_editor_auto_insert_event()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_auto_insert_event_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Pause While Typing -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="pauseWhileTypingCheck"
                    bind:checked={editorState.pauseWhileTyping}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="pauseWhileTypingCheck"
                    >{m.options_editor_pause_while_typing()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_pause_while_typing_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="pauseWhileTypeDuration"
                    >{m.options_editor_pause_duration()}</label
                >
                <input
                    class="form-control"
                    type="number"
                    min="1"
                    step="1"
                    bind:value={editorState.pauseWhileTypeDuration}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
            </div>
        </div>
    </div>
    <!-- Timing & Sync -->
    <div class="row">
        <p class="lead text-warning">{m.options_editor_section_timing_sync()}</p>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="selectNextEventCheck"
                    bind:checked={editorState.selectNextEvent}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="selectNextEventCheck"
                    >{m.options_editor_auto_select_next_event()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_auto_select_next_event_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="autoChainCheck"
                    bind:checked={editorState.autoChain}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="autoChainCheck"
                    >{m.options_editor_auto_chain_events()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_auto_chain_events_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="minFrameGap"
                    >{m.options_editor_min_frame_gap()}</label
                >
                <input
                    class="form-control"
                    type="number"
                    min="0"
                    step="1"
                    bind:value={editorState.minFrameGap}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
            </div>
        </div>
    </div>
    <!-- Timeline -->
    <div class="row">
        <p class="lead text-warning">{m.options_editor_section_timeline()}</p>
        <div class="col-4">
            <!-- Snap To Shot Changes -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="snapToShotChangesCheck"
                    bind:checked={editorState.snapToShotChanges}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="snapToShotChangesCheck"
                    >{m.options_editor_snap_to_shot_changes()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_snap_to_shot_changes_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Draw Events -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="drawEventsCheck"
                    bind:checked={editorState.drawEvents}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="drawEventsCheck"
                    >{m.options_editor_click_drag_create_events()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_click_drag_create_events_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Marker Comments -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="timelineOverlapProtectionCheck"
                    bind:checked={editorState.timelineOverlapProtection}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="timelineOverlapProtectionCheck"
                    >{m.options_editor_overlap_protection()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_overlap_protection_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Timeline Overlap Protection -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showMarkerCommentCheck"
                    bind:checked={editorState.showMarkerComment}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="showMarkerCommentCheck"
                    >{m.options_editor_show_marker_comments()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_show_marker_comments_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Film Strip -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showFilmstripCheck"
                    bind:checked={editorState.showFilmstrip}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="showFilmstripCheck"
                    >{m.options_editor_show_filmstrip()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_show_filmstrip_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Scroll to Zoom -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="scrollToZoomCheck"
                    bind:checked={editorState.scrollToZoom}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="scrollToZoomCheck"
                    >{m.options_editor_scroll_to_zoom()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_scroll_to_zoom_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Film Strip Frame Count -->
            <div class="mb-3">
                <label class="form-label" for="filmstripFrameCount"
                    >{m.options_editor_filmstrip_frame_count()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_filmstrip_frame_count_help()}
                    ></i></label
                >
                <input
                    class="form-control w-50"
                    type="number"
                    id="filmstripFrameCount"
                    min="1"
                    max="30"
                    step="1"
                    bind:value={editorState.filmstripFrameCount}
                    onchange={() => {
                        editorState.filmstripFrameCount = Math.min(
                            30,
                            Math.max(1, Math.round(Number(editorState.filmstripFrameCount) || 12))
                        );
                        updateEditorSettings();
                    }}
                />
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="timelineFontSize"
                    >{m.options_editor_timeline_font_size()}</label
                >
                <input
                    class="form-control w-50"
                    type="number"
                    min="1"
                    step="1"
                    bind:value={editorState.timelineFontSize}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="timelineFontColor"
                    >{m.options_editor_timeline_font_color()}</label
                >
                <input
                    class="form-control w-50"
                    type="color"
                    bind:value={editorState.timelineFontColor}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
            </div>
        </div>
    </div>
    <!-- Editor List Settings -->
      <div class="row">
          <p class="lead text-warning">{m.options_editor_section_editor_list()}</p>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="AutoFormatTextCheck"
                    bind:checked={editorState.autoFormatText}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />

                <label class="form-check-label" for="AutoFormatTextCheck"
                    >{m.options_editor_auto_format_on_paste()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="UpdateTimeOnEditCheck"
                    bind:checked={editorState.updateTimeOnEdit}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />

                <label class="form-check-label" for="UpdateTimeOnEditCheck"
                    >{m.options_editor_update_timing_on_edit()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="CollapsePositionStyleColumnCheck"
                    bind:checked={editorState.collapsePositionStyleColumn}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />

                <label class="form-check-label" for="CollapsePositionStyleColumnCheck"
                    >{m.options_editor_collapse_position_style()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_collapse_position_style_help()}
                    ></i></label
                >
            </div>
        </div>
     </div>    <!-- Audio Description -->
    <div class="row">
        <p class="lead text-warning">{m.options_editor_section_audio_description()}</p>
        <div class="col-4">
            <!-- Auto Trim Event -->
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="autoTrimEventCheck"
                    bind:checked={editorState.autoTrimEvent}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                />
                <label class="form-check-label" for="autoTrimEventCheck"
                    >{m.options_editor_auto_trim_event_time()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_auto_trim_event_time_help()}
                    ></i></label
                >
            </div>
        </div>
        <div class="col-4">
            <!-- Speaker Assignment Behavior -->
            <div class="mb-3">
                <label for="speakerAssignmentBehavior" class="form-label"
                    >{m.options_editor_speaker_assignment_behavior()} <i
                        class="bi bi-info-circle"
                        title={m.options_editor_speaker_assignment_behavior_help()}
                    ></i></label
                >
                <select
                    id="speakerAssignmentBehavior"
                    class="form-select"
                    bind:value={editorState.speakerAssignmentBehavior}
                    onchange={() => {
                        updateEditorSettings();
                    }}
                >
                    <option value="always">{m.options_editor_speaker_assignment_always()}</option>
                    <option value="new">{m.options_editor_speaker_assignment_new_only()}</option>
                    <option value="never">{m.options_editor_speaker_assignment_never()}</option>
                </select>
            </div>
        </div>
    </div>
</form>
